export { default } from './Switch';
export * from './Switch.types';
export { default as switchClasses } from './switchClasses';
export * from './switchClasses';